export type SecurityLevel = 'low' | 'medium' | 'high';

export type SecuritySettingsState = {
  autoLockEnabled: boolean;
  autoLockMinutes: number;
  fullscreenPinLockEnabled: boolean;
  pinHash: string;
  pinSalt: string;
  pinIterations: number;
  privacyMode: boolean;
  allowGuests: boolean;
  twoFactorEnabled: boolean;
  securityLevel: SecurityLevel;
};

export const PIN_ITERATIONS = 120000;

export const SECURITY_TIMEOUT_OPTIONS = [
  { value: 1, label: '1 minute' },
  { value: 5, label: '5 minutes' },
  { value: 15, label: '15 minutes' },
  { value: 30, label: '30 minutes' },
  { value: 60, label: '1 hour' },
] as const;

export const DEFAULT_SECURITY_SETTINGS: SecuritySettingsState = {
  autoLockEnabled: true,
  autoLockMinutes: 15,
  fullscreenPinLockEnabled: false,
  pinHash: '',
  pinSalt: '',
  pinIterations: PIN_ITERATIONS,
  privacyMode: false,
  allowGuests: false,
  twoFactorEnabled: false,
  securityLevel: 'medium',
};
